// usePromoSlots.js
// Drives the early-bird scarcity counter shown on the homepage, the /bid
// checkout form, and the navbar bid-rank widget — one shared fetch, three
// call sites. Server-cached 30s (get_promo_slots.js), so a light poll here
// is enough to keep a long-open tab from going stale without hammering it.
import { useEffect, useState } from 'react';

const POLL_MS = 60000;

export default function usePromoSlots({ enabled = true } = {}) {
  const [state, setState] = useState({
    slotsUsed: null,
    slotsTotal: null,
    baseDays: null,
    ready: false,
  });

  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;

    const pull = () => {
      fetch('/api/promo-slots')
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (stopped || !data || typeof data !== 'object') return;
          setState({
            slotsUsed: typeof data.slotsUsed === 'number' ? data.slotsUsed : null,
            slotsTotal: typeof data.slotsTotal === 'number' ? data.slotsTotal : null,
            baseDays: typeof data.baseDays === 'number' ? data.baseDays : null,
            ready: true,
          });
        })
        .catch(() => {});
    };

    pull();
    const timer = setInterval(pull, POLL_MS);
    return () => { stopped = true; clearInterval(timer); };
  }, [enabled]);

  const slotsRemaining = state.slotsTotal != null && state.slotsUsed != null
    ? Math.max(state.slotsTotal - state.slotsUsed, 0)
    : null;

  return { ...state, slotsRemaining };
}
